import { USER_EVENTS } from '@shared/core/user-events'
import { ALERT_CAMPAIGN_IDS, ALERT_CAMPAIGN_PRIORITIES, ALERT_CAMPAIGN_SEEN_EVENTS } from '../alerts.constants'
import { AlertCampaign } from '../alerts.types'

export const autoReminderModalCampaign: AlertCampaign = {
  id: ALERT_CAMPAIGN_IDS.AUTO_REMINDERS,
  priority: ALERT_CAMPAIGN_PRIORITIES.AUTO_REMINDERS,
  seenEventName: ALERT_CAMPAIGN_SEEN_EVENTS[ALERT_CAMPAIGN_IDS.AUTO_REMINDERS],
  isEligible: (context) => {
    if (context.profile === null) {
      return false
    }

    if (context.profile.usage_mode !== 'customer' || context.userEvents.has(USER_EVENTS.AUTO_REMINDERS_MODAL_SEEN)) {
      return false
    }

    return context.userEvents.has(USER_EVENTS.AUTO_REMINDERS_CALLOUT_ACTIVATED)
  },
}
